import { useMemo } from "react";
import { useAssets } from "../api/architecton/useAssets";
import { NATIVE_TON_ADDRESS } from "../constants/tokens";
export const useAssetBalance = ({ assetAddress, }) => {
    const { data: assetsData } = useAssets();
    const assetBalancesMap = useMemo(() => assetsData?.reduce((acc, asset) => {
        if (asset.asset.type === "native") {
            acc[NATIVE_TON_ADDRESS] = asset.balance;
            return acc;
        }
        acc[asset.asset.address] = asset.balance;
        return acc;
    }, {}) || {}, [assetsData]);
    return assetBalancesMap[assetAddress || NATIVE_TON_ADDRESS];
};
//# sourceMappingURL=useAssetBalance.js.map